import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { BaseDraggableWidget } from '../Card';
import { TemplateEditor } from '../../Attributes/Attributes_old';

const TITLE = 'Notes';
const DESCRIPTION = 'Enter description here';
const CATEGORY = 'System';

const Notes = ({ title, isPreview, ...rest }) => {
	const [query, setQuery] = useState('');

	const navigate = useNavigate();

	if (isPreview) {
		return (
			<BaseDraggableWidget
				title={TITLE}
				category={CATEGORY}
				description={DESCRIPTION}
				{...rest}
				isPreview={true}
			/>
		);
	}

	return (
		<BaseDraggableWidget title={TITLE} widgetProps={{}} {...rest}>
			<>
				<TemplateEditor quillClassName="h-full mb-2" toolbar={false} />
			</>
		</BaseDraggableWidget>
	);
};

export default Notes;
